module.exports = __webpack_public_path__ + "img/noPhoto.eb9e36c3.svg";